import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { ActionValidations } from '../../../models';
import styles from './AddActionForm.styles';
import { ACTION_TYPES, ACTION_OPTIONS } from '../../../constants/triggers';

import Button from '../../inputs/button/Button';
import AddForm from '../addform/AddForm';
import FormActions from '../formactions/FormActions';
import FormField from '../formfield/FormField';

export class AddActionForm extends Component {
  typeOptions = Object.values(ACTION_OPTIONS);
  render() {
    return (
      <AddForm onSubmit={this.props.handleSubmit} styles={styles.form}>
        <Field
          name="type"
          type="select-grid"
          component={FormField}
          maxLength="24"
          options={this.typeOptions}
          validate={ActionValidations.type}
        />
        {this.props.type === ACTION_TYPES.EMAIL && (
          <Field
            name="value"
            label={I18n.t('models.action.emailValue')}
            placeholder={I18n.t('models.action.emailValue')}
            type="text"
            component={FormField}
            validate={ActionValidations.email}
          />
        )}
        {this.props.type === ACTION_TYPES.SMS && (
          <Field
            name="value"
            label={I18n.t('models.action.smsValue')}
            placeholder={I18n.t('models.action.smsValue')}
            type="text"
            component={FormField}
            validate={ActionValidations.sms}
          />
        )}
        <FormActions>
          <Button>{I18n.t('add.save')}</Button>
          {this.props.isEditing && (
            <Button
              styles={styles.flatButton}
              type="button"
              onClick={this.props.onDelete}
            >
              {I18n.t('delete.delete')}
            </Button>
          )}
        </FormActions>
      </AddForm>
    );
  }
}

const selector = formValueSelector('addAction');
const mapStateToProps = state => {
  return {
    type: selector(state, 'type')
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addAction'
  })(AddActionForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/addactionform/AddActionForm.js